module.exports = __webpack_public_path__ + "img/icon-user.aac687b5.png";